
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import MedconnectDevices from "@/components/ui/cards/MedconnectDevicesCard"
import { MedconnectDeviceCardProps } from "@/components/ui/cards/MedconnectDevicesCard/MedconnectDeviceCard"
import CheckboxInput from '@/components/ui/inputs/CheckboxInput'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type MedconnectDevicesDialogProps = {
    open: boolean
    onClose: () => void
    devices: MedconnectDeviceCardProps[]
}

export default function MedconnectDevicesDialog(props: MedconnectDevicesDialogProps) {
    const { open, onClose, devices } = props
    const [showNavigator, setShowNavigator] = useState(false)

    const filteredDevices = devices.filter((device) => device.isLocal || showNavigator)
    const { t } = useTranslation()
    return (
        <Dialog
            fullWidth
            maxWidth='lg'
            onClose={onClose}
            open={open}
            scroll="paper"
        >
            <DialogContent>
                <CheckboxInput label={t('component.ui.MedconnectDevice.navigateur')} checked={showNavigator} onChange={(e) => setShowNavigator(e.target.checked)} />
                <MedconnectDevices devices={filteredDevices} />
            </DialogContent>
        </Dialog>

    )
}